import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import Papa, { ParseResult } from 'papaparse';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { FileUploadComponent } from '@shared/components';
import { DocumentCreateModel, FormModel, MocketBankTransactionActivity } from '@shared/models';

@Component({
  selector: 'app-upload-bulk-bank-activity',
  imports: [RktButtonDirective, FormsModule, ReactiveFormsModule, FileUploadComponent, RktIconComponent],
  templateUrl: './upload-bulk-bank-activity.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class UploadBulkBankActivityComponent {
  formModel: FormModel<Partial<DocumentCreateModel>> = {};
  isLoading = false;
  documentType!: string;
  documentUploadData?: File | null;
  transactionActivities: MocketBankTransactionActivity[] = [];

  constructor(public activeModal: ActiveModal) {}

  onFileUploaded(file: File | null) {
    if (file) {
      this.formModel.isFileUploaded = true;
      this.documentUploadData = file;
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results: ParseResult<MocketBankTransactionActivity>) => {
          this.transactionActivities = results.data;
        },
      });
    } else {
      this.formModel.isFileUploaded = false;
      this.documentUploadData = null;
    }
  }

  onSubmit() {
    if (!this.documentUploadData) {
      return;
    }

    this.activeModal.close({
      transactionActivities: this.transactionActivities,
      bulkTransactionActivity: this.documentUploadData,
      operation: 'UPLOAD',
    });
  }
}
